/**
 * Mobile PLP: sync title block height within each 2-column row
 * so SKU lines up without forcing a blank 4-line gap on short titles.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var MAX_LINES = 4;
  var GRID_SELECTOR = '.product-grid.grid--2-col-tablet-down';
  var HEADING_SELECTOR =
    '.card--standard > .card__content .card__heading';
  /* .price may be nested in .promo-deals-price / .promo-clearance-hide-discount */
  var PRICE_SELECTOR =
    '.card--standard > .card__content .card-information .price';

  function getTitleNode(heading) {
    if (!heading) return null;
    return (
      heading.querySelector('.full-unstyled-link') ||
      heading.querySelector('.card__title-text')
    );
  }

  function measureTitleHeight(heading) {
    var titleNode = getTitleNode(heading);
    if (!titleNode) return 0;

    heading.style.minHeight = '';
    var lineHeight = parseFloat(getComputedStyle(titleNode).lineHeight) || 21;
    var maxHeight = lineHeight * MAX_LINES;
    return Math.min(titleNode.scrollHeight, maxHeight);
  }

  function setTitleBlockHeight(heading, heightPx) {
    heading.style.minHeight = heightPx + 'px';
    var info = heading.closest('.card__information');
    if (info) {
      info.style.setProperty('--plp-title-block-height', heightPx + 'px');
    }
  }

  function clearTitleBlockHeight(heading) {
    heading.style.minHeight = '';
    var info = heading.closest('.card__information');
    if (info) {
      info.style.removeProperty('--plp-title-block-height');
    }
  }

  function clearPriceBlockHeight(price) {
    price.style.minHeight = '';
  }

  function measurePriceHeight(price) {
    clearPriceBlockHeight(price);
    return price.offsetHeight;
  }

  function setPriceBlockHeight(price, heightPx) {
    price.style.minHeight = heightPx + 'px';
  }

  function syncRowPair(items) {
    var headings = items
      .map(function (item) {
        return item.querySelector(HEADING_SELECTOR);
      })
      .filter(Boolean);

    var prices = items
      .map(function (item) {
        return item.querySelector(PRICE_SELECTOR);
      })
      .filter(Boolean);

    if (!headings.length && !prices.length) return;

    var maxTitleHeight = 0;
    headings.forEach(function (heading) {
      var h = measureTitleHeight(heading);
      if (h > maxTitleHeight) maxTitleHeight = h;
    });

    headings.forEach(function (heading) {
      setTitleBlockHeight(heading, maxTitleHeight);
    });

    var maxPriceHeight = 0;
    prices.forEach(function (price) {
      var h = measurePriceHeight(price);
      if (h > maxPriceHeight) maxPriceHeight = h;
    });

    prices.forEach(function (price) {
      setPriceBlockHeight(price, maxPriceHeight);
    });
  }

  function syncPlpCardTitles() {
    if (!MOBILE_MQ.matches) {
      document.querySelectorAll(GRID_SELECTOR + ' ' + HEADING_SELECTOR).forEach(clearTitleBlockHeight);
      document.querySelectorAll(GRID_SELECTOR + ' ' + PRICE_SELECTOR).forEach(clearPriceBlockHeight);
      return;
    }

    document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
      var items = Array.prototype.slice
        .call(grid.querySelectorAll(':scope > .grid__item'))
        .filter(function (item) {
          return item.style.display !== 'none';
        });

      for (var i = 0; i < items.length; i += 2) {
        syncRowPair(items.slice(i, i + 2));
      }
    });
  }

  var debounceTimer;
  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncPlpCardTitles, 80);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  MOBILE_MQ.addEventListener('change', scheduleSync);
  window.addEventListener('resize', scheduleSync);
  window.addEventListener('load', scheduleSync);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(GRID_SELECTOR).forEach(function (grid) {
      new MutationObserver(scheduleSync).observe(grid, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    });
  });

  window.syncPlpCardTitles = syncPlpCardTitles;
})();
